import { ApiService } from '../apiService'

export const updateSiteTask = async (taskId, site_task) => {
  const response = await ApiService.patch(`/calendar_tasks/${taskId}.json`, {
    site_task,
  })
  return response.site_task
}
